import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { useHistory } from 'react-router';
import TW_log from '../machineUI/NaviBar/icons/travel-wifi-logo.png';
import localRequest from '../services/LocalServer/localRequest';
import Cookies from 'js-cookie';

export default function CashPayment(props) {
  const isLocal = localStorage.getItem('ISLOCAL') === 'TRUE';
  const [one, setone] = useState(true);
  let history = useHistory();
  const { t } = useTranslation();
  const machineID = props.id;

  let separateItem = JSON.parse(localStorage.getItem('SeparateItem'));
  let symbol = JSON.parse(localStorage.getItem('machine'))?.currency?.symbol;
  symbol = symbol ? symbol : '$';
  const order_info = JSON.parse(localStorage.getItem('order_info'));

  const [mainL, setMainL] = useState('en-US');

  const [paid, setPaid] = useState(0);

  useEffect(() => {
    const mycoockie = Cookies.get('i18next');
    if (mycoockie === 'fr') {
      setMainL('fr-CA');
    } else if (mycoockie === 'es') {
      setMainL('es-US');
    }
  }, []);

  separateItem = separateItem.filter((e) => e.prodType === 'prod');

  const prods = separateItem.map((prod, i) => {
    // console.log(prod);
    // const url = `${process.env.REACT_APP_SERVER_API}/pictures/${prod.picture}/${prod.referTo}`;
    const url = isLocal
      ? `${process.env.REACT_APP_LOCAL_API}/pictures/products/${prod.picture}`
      : `${process.env.REACT_APP_SERVER_API}/pictures/${prod.picture}/${prod.referTo}`;
    return (
      <div className="payment-product-card" key={i}>
        <img className="card-img" src={url} alt=""></img>
        <div className="payment-card-text">{prod.product_name}</div>
      </div>
    );
  });

  const cancelButton = async () => {
    if (one) {
      await localRequest({
        method: 'post',
        url: `${process.env.REACT_APP_LOCAL_API}/paymentUpdate`,
        data: {
          status: 'CANCEL',
        },
      }).then((res) => {
        console.log('back');
        setone(false);
        setTimeout(() => {
          history.goBack();
        }, 3000);
      });
    }
  };

  useEffect(() => {
    // payment status request
    var interval = setInterval(() => fetchAPI(), 500);
    // out of order request
    // var outInterval = setInterval(() => outOfOrderRequest(outInterval, machineID), 2000);

    async function fetchAPI() {
      // console.log('featchAPI');
      await axios
        .get(`${process.env.REACT_APP_LOCAL_API}/paymentStatus`, {
          headers: {
            'X-CompanyID': 'magex',
            'X-Token': process.env.REACT_APP_X_TOKEN,
          },
        })
        .then(async (status) => {
          if (status.data.status_message) {
            // setMessage(status.data.status_message);
          }

          if (status.data.status === 'SUCCESS' || status.data.status === 'RUNNING') {
            setPaid(status.data.credit);
            if (status.data.status === 'SUCCESS') {
              clearInterval(interval);
              setTimeout(() => {
                localStorage.setItem('payment_type', 'Cash');
                history.push(`/machineUI/product-dispense/${machineID}`);
              }, 4000);
            }
          } else if (status.data.status === 'PAYMENTERROR') {
            // setMessage('Payment error, back to previous page');
            setTimeout(() => {
              history.goBack();
            }, 3000);
          }
          const dataDate = new Date(status.data.date);
          const nowDate = new Date();

          const dif = nowDate.getTime() - dataDate.getTime();
          // console.log(dif);
          if (dif < 30000) {
            props.setIdle(dif);
          }
        });
    }

    return () => {
      clearInterval(interval);
      // clearInterval(outInterval);
    };

    // history.push(`/machineUI/product-dispense/${machineID}`);
  }, []);

  return (
    <div className="payment-container">
      <div className="payment-container-div">
        <img className="payment-logo-img" src={TW_log} alt=""></img>
        <div className="payment-products-container">{prods}</div>
        <div className="payment-line mb-4"></div>
        <div className="payment-cash-div">
          <div>
            <span className="payment-cash-left-med">{t('Subtotal')}</span>
            <span className="payment-cash-right">
              {mainL !== 'fr-CA' && symbol}
              {(order_info.total_amount - order_info.tax_amount).toFixed(2)}
              {mainL === 'fr-CA' && symbol}
            </span>
          </div>
          <div>
            <span className="payment-cash-left-med">{t('Tax')}</span>
            <span className="payment-cash-right">
              {mainL !== 'fr-CA' && symbol}
              {order_info.tax_amount.toFixed(2)}
              {mainL === 'fr-CA' && symbol}
            </span>
          </div>
          <div className="payment-line mt-3 mb-4" style={{ width: '100%' }}></div>
          <div>
            <span className="payment-cash-left">{t('Total')}</span>
            <span className="payment-cash-right">
              {mainL !== 'fr-CA' && symbol}
              {order_info.total_amount.toFixed(2)}
              {mainL === 'fr-CA' && symbol}
            </span>
          </div>
          <div>
            <span className="payment-cash-left">{t('Amount Paid')}</span>
            <span className="payment-cash-right">
              {mainL !== 'fr-CA' && symbol}
              {paid.toFixed(2)}
              {mainL === 'fr-CA' && symbol}
            </span>
          </div>
          <div>
            <span className="payment-cash-left">{t('Amount Due')}</span>
            <span className="payment-cash-right">
              {mainL !== 'fr-CA' && symbol}
              {order_info.total_amount.toFixed(2)}
              {mainL === 'fr-CA' && symbol}
            </span>
          </div>
          <div style={{ marginTop: '550px' }}>
            <span className="payment-cash-left">{t('Balance')}</span>
            <span className="payment-cash-right-bold">
              {mainL !== 'fr-CA' && symbol}
              {(paid - order_info.total_amount).toFixed(2)}
              {mainL === 'fr-CA' && symbol}
            </span>
          </div>
        </div>
        <div className="view-more-button payment-cancel-button" onClick={cancelButton}>
          {t(`CANCEL`)}
        </div>
      </div>
    </div>
  );
}
